import { render, staticRenderFns } from "./LeadsJourney.vue?vue&type=template&id=717ba46e&scoped=true&"
import script from "./LeadsJourney.vue?vue&type=script&lang=js&"
export * from "./LeadsJourney.vue?vue&type=script&lang=js&"
import style0 from "./LeadsJourney.vue?vue&type=style&index=0&id=717ba46e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ba46e",
  null
  
)

export default component.exports